import type { DateKey, GeoPoint, Hour } from '../data/types';

/** 13.5 → "1:30 pm". */
export function fmtHour(h: Hour): string {
  const total = Math.round(h * 60);
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  const suffix = hh >= 12 ? 'pm' : 'am';
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${h12}:${String(mm).padStart(2, '0')} ${suffix}`;
}

/** Duración 1.5 → "1 h 30". */
export function fmtDuration(h: number): string {
  const total = Math.round(h * 60);
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  if (hh === 0) return `${mm} min`;
  return mm ? `${hh} h ${mm}` : `${hh} h`;
}

export function addDays(date: DateKey, days: number): DateKey {
  if (!date || typeof date !== 'string') return '';
  const [y, m, d] = date.split('-').map(Number);
  if (!y || !m || !d || isNaN(y) || isNaN(m) || isNaN(d)) return '';
  const dt = new Date(Date.UTC(y, m - 1, d + days));
  if (isNaN(dt.getTime())) return '';
  return dt.toISOString().slice(0, 10);
}

const DOW = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const MON = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

export function dayLabel(date: DateKey, today: DateKey): string {
  if (date === today) return 'Hoy';
  if (date === addDays(today, 1)) return 'Mañana';
  const [y, m, d] = date.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  return `${DOW[dt.getUTCDay()]} ${d}`;
}

export function longDate(date: DateKey): string {
  const [y, m, d] = date.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  const names = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  return `${names[dt.getUTCDay()][0].toUpperCase()}${names[dt.getUTCDay()].slice(1)} ${d} de ${MON[m - 1]}`;
}

/** Redondea hacia arriba a la siguiente media hora. */
export function ceilHalfHour(h: Hour): Hour {
  return Math.ceil(h * 2 - 1e-9) / 2;
}

/** Distancia en millas (haversine). */
export function miles(a: GeoPoint, b: GeoPoint): number {
  const R = 3958.8;
  const toRad = (x: number) => (x * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const s = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return Math.round(2 * R * Math.asin(Math.sqrt(s)) * 10) / 10;
}
